import styled from 'styled-components';

const FaqContentStyle = styled.section`
	--distanceButton: var(--sp3x);
	--distanceCategories: var(--sp4x);
	--distanceButtonCategories: var(--sp9x);
	--distanceGrid: var(--sp3x);
	--faqDescriptionTop: var(--sp3x);
	--faqDescriptionBottom: var(--sp7x);
	--sizeArrow: var(--sp3x);

	.wrapper-button-categories {
		display: flex;
		flex-direction: column;
		gap: var(--distanceButtonCategories);
	}

	.wrapper-button-control {
		display: flex;
		flex-wrap: wrap;
		gap: var(--distanceButton);

		.btn {
			z-index: 13;
		}
	}

	.wrapper-all-categories {
		display: flex;
		flex-direction: column;
		gap: var(--distanceCategories);
	}

	.category {
		a,
		button {
			text-transform: capitalize;
		}
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			.title-answer-wrapper {
				&:hover {
					.collapse-icon {
						opacity: 1;
					}
				}
			}
		}
	}

	.wrapper-container {
		display: grid;
		grid-template-columns: 5fr 1fr 6fr;
		justify-content: space-between;
	}

	.description-faq {
		margin-top: var(--faqDescriptionTop);
		margin-bottom: var(--faqDescriptionBottom);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceButton: var(--sp2x);
		--distanceCategories: var(--sp4x);
		--distanceButtonCategories: var(--sp6x);
		--faqDescriptionTop: var(--sp3x);
		--faqDescriptionBottom: var(--sp6x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceButton: var(--sp2x);
		--distanceCategories: var(--sp4x);
		--distanceButtonCategories: var(--sp6x);
		--sizeArrow: var(--sp2x);

		.wrapper-container {
			display: grid;
			grid-template-columns: 6fr 6fr;
			justify-content: space-between;
			gap: var(--distanceGrid);

			.empty {
				display: none;
			}
		}
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--distanceButton: var(--sp1-5x);
		--distanceCategories: var(--sp3x);
		--distanceButtonCategories: var(--sp6x);
		--distanceGrid: var(--sp2-5x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--distanceButton: var(--sp1x);
		--distanceCategories: var(--sp3x);
		--distanceButtonCategories: var(--sp4x);
		--distanceGrid: var(--sp2x);
		--faqDescriptionTop: var(--sp3x);
		--faqDescriptionBottom: var(--sp4x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--distanceButton: var(--sp1x);
		--distanceCategories: var(--sp3x);
		--distanceButtonCategories: var(--sp4x);
		--distanceGrid: var(--sp2x);
		--faqDescriptionTop: var(--sp2x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceButton: var(--sp1x);
		--distanceCategories: var(--sp3x);
		--distanceButtonCategories: var(--sp3x);
		--distanceGrid: var(--sp6x);

		.wrapper-container {
			display: flex;
			flex-direction: column;
		}
	}
`;
export default FaqContentStyle;
